import {FC} from 'react';
import {RegistrationCompleteIcon} from 'shared/assets/icons';
import {
	REGISTRATION_COMPLETE_DESCRIPTION,
	REGISTRATION_COMPLETE_TITLE,
} from '../../model';
import {StepLayout} from 'features/registration';
import styles from './RegistrationCompleteStep.module.css';

export const RegistrationCompleteStep: FC = () => (
	<StepLayout variant="fill" className={styles.root}>
		<StepLayout.Intro
			title={REGISTRATION_COMPLETE_TITLE}
			subtitle={REGISTRATION_COMPLETE_DESCRIPTION}
		/>

		<StepLayout.Content className={styles.illustration}>
			<RegistrationCompleteIcon className={styles.illustrationIcon} />
		</StepLayout.Content>
	</StepLayout>
);
